import { MainAppState } from "../main/types";

export const getIsRequestingLocation = (state: MainAppState): boolean =>
  state.findMyPax.isRequestingLocation;
